// config.js
// export default config;

export const TrNumbePrefix = "056031";

// const config = {
//   apiBaseUrl: "http://localhost:5000", // Your API base URL
// };

// const config = {
//   apiBaseUrl: "https://test.kanpurfolk.in", // Your API base URL
// };

const config = {
  apiBaseUrl: "https://www.kanpurfolk.in", // Your API base URL
};

export const AppName = {
  appName: "Folk ERP",
};

export default config;
